import React, { useState, useEffect } from "react";
import DynamicTable from "./DynamicTable";
import Popup from "reactjs-popup";
import "./Form.css";
import { biltyApiConfig } from "../config/apiConfig.js";
import { SERVER_URL, USE_OVERLAY } from "../config/config";
import FormColumn from "./FormColumn.js";
import LoadingOverlay from "react-loading-overlay";
import "./FieldView.css";
import {
  groupInfo,
  validate,
  dataObject,
  popupInfo,
} from "../config/Biltyform.js";
import {
  itemTableHeader,
  itemTableItems,
  ewbTableItems,
  ewbTableHeader,
} from "../config/tableItems";
import Autosuggest from "react-autosuggest";
import "./AutoSuggest.css";
import useForm from "./useForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./popup.css";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "../components/ComponentToPrint";
import { useHistory, useLocation } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DynamicViewTable from "./DynamicViewTable";
// import ReportTable from "./ReportTable";
import ReportExcel from "./ReportExcel.js";


let crossVal = true;
const FormSignup = ({ sessionObject, itemNamesDict, crossingVal }) => {
  const [isPrint, setIsPrint] = React.useState(false);
  const [popupLoading, setPopupLoading] = React.useState(true)
  const [printData, setPrintData] = React.useState([]);
  crossVal = crossingVal;
  const [selectedType, setSelectedType] = useState(''); 
  const [transportMode, setTransportMode] = useState('');
  const [weightMode, setWeightMode] = useState('');



  const packingType = itemTableItems.find(item => item.name === "packing_type");
    packingType.dropdown_items = Object.keys(itemNamesDict).map(key => ({
      value: key,
      label: itemNamesDict[key],
  }));


  const location = useLocation();
  const [locationData, setLocationData] = useState({});
  console.log("Location Info",location)

  const [podOpen, setPodOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [podImageOpen, setPodImageOpen] = useState(false);
  const [podUploadPopup, setPodUploadPopup] = useState({
    open: false,
    header: "",
    message: "",
  });
  const [isPodButtonDisabled, setIsButtonDisabled] = useState(true);
  const showFlagPod = () => {
    setPodOpen(!podOpen);
  };
  const [rotationAngle, setRotationAngle] = useState(270);

   const handleImageUpload = async () => {
    try {
      setPodOpen(false);

      let file = await new Promise((resolve) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = (event) => resolve(event.target.files[0]);
        input.click();
      });

      if (!file) return;

      myForm.setOverlay(true);

      const apiUrl = `${SERVER_URL}/pod_image/?image_id=${
        myForm.pageState.bilty_id
      }&type=bilty_pod&client_name=jkl`;

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Upload failed. Please try again.");
      }

      const responseData = await response.json();

      if (responseData.status_code == 407) {
        setPodUploadPopup({
          open: true,
          header: "Upload Failed",
          message: "The QR code could not be detected in the uploaded image.",
        });
      } else if (responseData.status_code == 406) {
        setPodUploadPopup({
          open: true,
          header: "Upload Failed",
          message: "The uploaded QR code does not match the selected bilty.",
        });
      } else {
        setPodUploadPopup({
          open: true,
          header: "Upload Successful",
          message: "The POD image was uploaded successfully.",
        });
      }
    } catch (error) {
      console.error("Upload Error:", error);
      setPodUploadPopup({
        open: true,
        header: "Upload Failed",
        message: "Failed to upload image. Please try again.",
      });
    } finally {
      myForm.setOverlay(false);
    }
  };

  const handleRotate = () => {
    setRotationAngle((prevAngle) => prevAngle + 90);
  };

  useEffect(() => {
    
    const lData = location.state ?? {};
    console.log("lData is Here ",lData)
    if ("biltyNo" in lData) {
      setLocationData(lData);
      myForm.setPageState((oldState) => ({
        ...oldState,
        bilty_no: lData.biltyNo,
        suffix: lData.suffix,
      }));
    }
    console.log("Form Checking Data ",myForm.pageState)
  }, []);

  useEffect(() => {
    if ("biltyNo" in locationData) {
      const fakeKey = { key: "Enter" };
      myForm.getPageOnKeyEnter(fakeKey, locationData.biltyNo);
    }
  }, [locationData]);

  const history = useHistory();
  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    role_id: String(sessionObject.sessionVariables.role_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
    suffix: sessionObject.sessionVariables.branch_suffix,
    created_by_name: String(sessionObject.sessionVariables.user_name),
    // "last_bilty_no": String(sessionObject.sessionVariables.last_bilty_no),
  };
  const myForm = useForm(
    "Bilty",
    validate,
    { ...dataObject, ...variablesFromSession },
    biltyApiConfig,
    itemNamesDict
  );

  useEffect(() => {
    const callApi = async () => {
      if (myForm.pageState.bilty_id && myForm.pageState.is_pod_image == 1) {
        const apiUrl = `${SERVER_URL}/pod_image/?bilty_id=${myForm.pageState.bilty_id}`;
        const response = await fetch(apiUrl);
        if (response.status === 200) {
          const blob = await response.blob();
          const imageObjectUrl = URL.createObjectURL(blob);
          setImageUrl(imageObjectUrl);
          setIsButtonDisabled(false);
        } else {
          console.error("API call failed with status:", response.status);
          setIsButtonDisabled(true);
        }
      } else {
        console.log("Conditions not met. Skipping API call.");
        setIsButtonDisabled(true);
      }
    };

    callApi();
  }, [myForm.pageState.bilty_id, myForm.pageState.is_pod_image]);

  const handleDownloadPod = async () => {
    try {
      const apiUrl = `${SERVER_URL}/pod_image/?bilty_id=${myForm.pageState.bilty_id}`;
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blob = await response.blob();
      const downloadLink = document.createElement("a");
      const blobUrl = URL.createObjectURL(blob);
      downloadLink.href = blobUrl;
      downloadLink.download = "pod_image.jpg";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const accountDetailTableHeader = [
    { label: "Sr. No.", className: "text-center table-header" },
    { label: "Debit Party Name", className: "text-center table-header" },
    { label: "Credit Party Name", className: "text-center table-header" },
    // { label: "Credit", className: "text-center table-header" },
    { label: "Amount", className: "text-center table-header" },
    { label: "Voucher Id", className: "text-center table-header" },
    { label: "Voucher Type", className: "text-center table-header" },
    { label: "Remarks", className: "text-center table-header" },
  ];

  const accountDetailTableItems = [
    // {
    //   type: "number",
    //   name: "credit",
    //   label: "Credit",
    //   className: "form-control-medlarge-col",
    // },
    {
      type: "text",
      name: "source_party_name",
      label: "Debit Party Name",
      className: "form-control-medlarge-col",
    },
    {
      type: "text",
      name: "party_name",
      label: "Source Party Name",
      className: "form-control-medlarge-col",
    },
    {
      type: "number",
      name: "debit",
      label: "Amount",
      className: "form-control-medlarge-col",
    },
    {
      type: "number",
      name: "voucher_id",
      label: "Voucher Id",
      className: "form-control-medlarge-col",
    },
    {
      type: "text",
      name: "voucher_type",
      label: "Voucher Type",
      className: "form-control-medlarge-col",
    },
    {
      type: "text",
      name: "remarks",
      label: "Remarks",
      className: "form-control-medlarge-col",
    },
  ];

  const handleCheckboxChangeRR = (arr, item, idx) => {
    console.log("item", item,idx);
    console.log("arrr", arr.target, arr.target.checked);
    let dummyArray = printData;

    if (arr.target.checked) {
      dummyArray[idx].checked = "1";
    } else {
      dummyArray[idx].checked = "0";
    }
    console.log("bilty ids dummy", dummyArray);
    setPrintData([...dummyArray]);
};

  const typeOfShippingMap = {
    FTL: 1,
    PTL: 2,
  };

  const modeOfTransportationMap = {
    Road: 3,
    Rail: 4,
    Ship: 5,
    Air: 6,
  };
  const typeOfWeightMap = {
    CFT: 11,
    LBH: 12,
    Normal: 13,
    Liter: 14,
    FTL: 15,
  };

  useEffect(() => {
    
    myForm.setPageState(oldState => ({
      ...oldState,
      type_of_shipping: typeOfShippingMap[selectedType] || oldState.type_of_shipping,
      mode_of_transportation: modeOfTransportationMap[transportMode] || oldState.mode_of_transportation,
      // type_of_weight: typeOfShippingMap[selectedType] === 1 ? null : typeOfWeightMap[weightMode] || oldState.type_of_weight, 
      type_of_weight: typeOfWeightMap[weightMode] || oldState.type_of_weight,
    }));
  }, [selectedType, transportMode, weightMode]);
  
  const deselectAllRR = () => {
    let dummyArray = printData;
    for (let i = 0; i < dummyArray.length; i++) {
        dummyArray[i].checked = "0";
    }
    setPrintData([...dummyArray]);
  };

  const selectAllRR = () => {
    let dummyArray = printData;
    for (let i = 0; i < dummyArray.length; i++) {
        dummyArray[i].checked = "1";
    }
    setPrintData([...dummyArray]);
  };

  const getSelectAllValueRR = () => {
      for (let i = 0; i < printData.length; i++) {
          if (printData[i].checked != "1") {
              return false;
          }
      }
      return true;
  };



  useEffect(() => {
    const fetchDistanceByPincode = async () => {
      try {
        if (myForm.pageState.from_pincode.length !== 6 || myForm.pageState.to_pincode.length !== 6) {
          console.log("Pincode is missing or invalid pincode format.");
          return;
        }

        const apiUrl = `${SERVER_URL}/bilty/km_get_distance_by_pincode?from_pincode=${myForm.pageState.from_pincode}&to_pincode=${myForm.pageState.to_pincode}`;
        
        const resp = await fetch(apiUrl, { 
          method: "POST",
          headers: {
            'accept': 'application/json',
          }
        });

        if (!resp.ok) {
          throw new Error(`HTTP error! status: ${resp.status}`);
        }

        const data = await resp.json();

        if ("distance_km" in data) {
          myForm.setPageState((oldState) => ({
            ...oldState,
            item_in: oldState.item_in.map((item, idx) =>
              idx === 0 ? { 
                ...item, 
                total_kms: data.distance_km,
              } : item
            ),
          }));
        }
      } catch (error) {
        console.error("Error fetching distance by pincode:", error);
      }
    };

    if (
      myForm.pageState?.is_wipro === true &&
      myForm.pageState?.type_of_shipping === 1 &&
      myForm.pageState.from_pincode &&
      myForm.pageState.to_pincode
    ) {
      fetchDistanceByPincode();
    }
  }, [
    myForm.pageState.to_pincode,
    myForm.pageState.from_pincode, 
    myForm.pageState?.is_wipro,
    myForm.pageState?.type_of_shipping
  ]);

  

  useEffect(() => {
    if (!crossingVal) {
      myForm.setPageState(oldState => ({
        ...oldState,
        is_crossing: "N"
      }));
    } else {
      myForm.setPageState(oldState => ({
        ...oldState,
        is_crossing: "Y"
      }));
    }
  }, [crossingVal]);

 
  
  useEffect(() => {
    myForm.setPageStateByField("consignee", myForm.pageState.consignee_id);
  }, [myForm.pageState.consignee_id]);

  if(process.env.REACT_APP_CLIENT == "jkl") {
    useEffect(() => {
      myForm.setPageState((oldState) => ({
        ...oldState,
        bilty_charge: 50,
      }));
    }, []);
  }

  const getRateUnits = async () => {

    if (myForm.pageState.is_wipro === true && myForm.pageState.type_of_shipping === 1) {
      console.log("Skipping getRateUnits for Wipro FTL - will handle rate calculation separately");
      return;
    }

    const url =
      SERVER_URL +
      "/party_rate/get_party_units?" +
      `consignor_id=${myForm.pageState.consignor_id}` +
      `&station_from=${myForm.pageState.station_from}` +
      `&station_to=${myForm.pageState.station_to}`;

    let resp = await fetch(url, {
      method: "POST",
    });

    if (resp.ok) {
      let respData = await resp.json();
      console.log({ respData });

      // if super admin, don't change unit list
      if (
        "units" in respData &&
        sessionObject.sessionVariables.role_id != "1"
      ) {
        itemTableItems[1].dropdown_items = respData.units.map((item) => {
          return {
            value: item,
            label: item,
          };
        });
      }

      if ("name" in respData) {
        myForm.setPageState((oldState) => ({
          ...oldState,
          item_in: [
            {
              ...oldState.item_in[0],
              amount: respData.rate,
              item_id: respData.item_id,
              item_name: respData.name,
              rate: respData.rate,
              unit: respData.units[0],
              rate_info: [],
            },
          ],
        }));
      } else {
        myForm.setPageState((olState) => ({
          ...olState,
          item_in: [
            {
              amount: "",
              item_name: "",
              pkgs: olState.item_in[0].pkgs,
              rate: "",
              unit: "W",
              weight: olState.item_in[0].weight,
              new_row: "N",
              packing_type: "1",
              vehicle_type: "1",
              box_capacity: "150",
              vehicle_size: "800 KG",
              rate_info: [],
              cft: ""
            },
          ],
        }));
      }
    }
  };

  // useeffect to fetch rate units and item
  useEffect(() => {
    if(process.env.REACT_APP_CLIENT == "shubham") {
      if(parseInt(process.env.REACT_APP_CHALLAN_FTL_MODE) == 0) {
        if (myForm.pageMode != "view" && myForm.pageState.pay_type == "4") {
          getRateUnits();
        }
      }
    } else {
      if (myForm.pageMode != "view" && myForm.pageState.pay_type == "4" && process.env.REACT_APP_CLIENT != "xpress" ) {
        getRateUnits();
      }
    }
  }, [
    myForm.pageState.station_from,
    myForm.pageState.consignor_id,
    myForm.pageState.station_to,
    myForm.pageState.pay_type,
  ]);

  // useeffect to fetch unit and rate beforehand if item has only one unit and rate
  // set available units for current item as well.
  useEffect(() => {
    if (myForm.pageMode != "view" && myForm.pageState.pay_type == "4") {
      const changeUnitsList = (newList) => {
        if (!newList.length) {
          return;
        }
        itemTableItems[1].dropdown_items = newList.map((item) => {
          return {
            value: item.toUpperCase(),
            label: item.toUpperCase(),
          };
        });

        myForm.setPageState((oldState) => {
          return { ...oldState };
        });
      };

      let rateInfo = myForm.pageState.item_in[0].rate_info ?? [];
      if (rateInfo == "") {
        rateInfo = [];
      }

      console.log("Available rateInfo:", rateInfo);

      // if only one rate unit is there, dont wait for hit of enter on unitRate dropdown
      // instead fetch rate-unit here.
      if (myForm.pageState.type_of_shipping !== 1 && rateInfo.length === 1) {
        myForm.setPageState((oldState) => ({
          ...oldState,
          item_in: [
            {
              ...oldState.item_in[0],
              rate: rateInfo[0].rate,
              unit: rateInfo[0].unit.toUpperCase(),
            },
          ],
        }));
      }

      // When shipping type is PTL (2), match unit and update rate
      if (myForm.pageState.type_of_shipping === 2 && rateInfo.length > 0) {
        myForm.setPageState((oldState) => {
          const currentUnit = oldState.item_in[0].unit;
          const matched = rateInfo.find(
            (r) => r.unit?.toUpperCase() === currentUnit?.toUpperCase()
          );

          if (matched) {
            console.log(
              "Matched unit in rateInfo:",
              currentUnit,
              "→ rate:",
              matched.rate
            );

            return {
              ...oldState,
              item_in: [
                {
                  ...oldState.item_in[0],
                  rate: matched.rate,
                },
              ],
            };
          }

          return oldState;
        });
      }

      if (myForm.pageState.role_id != "1") {
        let unitList = [];
        rateInfo.forEach((obj) => {
          if (unitList.indexOf(obj.unit) == -1) {
            unitList.push(obj.unit);
          }
        });
        changeUnitsList(unitList);
      }
    }
  }, [myForm.pageState.item_in[0].rate_info]);

  useEffect(() => {
    const typeOfShipping = myForm.pageState.type_of_shipping;
  
    if (typeOfShipping !== 1) return;
  
    const item = myForm.pageState.item_in?.[0];
    const rateInfo = item?.rate_info ?? [];
    const selectedVehicleValue = item?.vehicle_type;
    const totalKms = parseFloat(item?.total_kms) || 0;
    const isWipro = myForm.pageState.is_wipro === true;

    if (!selectedVehicleValue || rateInfo.length === 0) return;
  
    const vehicleTypeDropdownItems = [
      { value: "1", label: "19FT" },
      { value: "2", label: "3.5MT" },
      { value: "3", label: "5MT" },
      { value: "4", label: "7MT" },
      { value: "5", label: "9MT" },
      { value: "6", label: "BOLLORE/DOST" },
      { value: "7", label: "CANTER" },
      { value: "8", label: "CHAMPION" },
      { value: "9", label: "PICK-UP" },
      { value: "10", label: "TATA ACE" },
      { value: "11", label: "TATA 1109" },
      { value: "12", label: "Tata 407" }
    ];
  
    const selectedVehicleLabel = vehicleTypeDropdownItems.find(
      (v) => v.value === selectedVehicleValue
    )?.label?.toLowerCase()?.trim();
  
    if (!selectedVehicleLabel) return;
  
    const matchedRateObj = rateInfo.find((rateObj) => {
      return rateObj.truck_size?.toLowerCase()?.trim() === selectedVehicleLabel;
    });
  
    if (matchedRateObj) {
      let finalRate = parseFloat(matchedRateObj.rate) || 0;
      let finalAmount = finalRate;

      if (isWipro && matchedRateObj.min_kms && matchedRateObj.after_min_km_cost) {
        const minKms = parseFloat(matchedRateObj.min_kms) || 0;
        const afterMinKmCost = parseFloat(matchedRateObj.after_min_km_cost) || 0;

        if (totalKms > minKms) {
          const exceededKms = totalKms - minKms;
          const additionalCost = exceededKms * afterMinKmCost;
          finalRate = finalRate + additionalCost;
          finalAmount = finalRate;
        }
      }

      myForm.setPageState((oldState) => ({
        ...oldState,
        item_in: [
          {
            ...oldState.item_in[0],
            rate: finalRate,
            amount: finalAmount,
            unit: matchedRateObj.unit?.toUpperCase() || "",
          },
        ],
      }));
    } else {
      myForm.setPageState((oldState) => ({
        ...oldState,
        item_in: [
          {
            ...oldState.item_in[0],
            amount: "",
            rate: "",
            unit: "",
          },
        ],
      }));
    }
  }, [
    myForm.pageState.item_in?.[0]?.vehicle_type, 
    myForm.pageState.type_of_shipping,
    myForm.pageState.item_in?.[0]?.total_kms,
    myForm.pageState.is_wipro
  ]);
  

  // useEffect for, if we change paytype then existing info of item should be discarded
  useEffect(() => {
    if (
      myForm.pageMode != "view" &&
      myForm.pageState.pay_type != "4" &&
      myForm.pageState.prev_pay_type == "4" &&
      process.env.REACT_APP_CLIENT != "xpress"
    ) {
      myForm.setPageState((olState) => ({
        ...olState,
        item_in: [
          {
            ...myForm.pageState.item_in[0],
            rate: "",
            amount: "",
            //   item_name: "",
            //   pkgs: "",
            //   rate: "",
            //   unit: "C",
            //   weight: "",
            //   new_row: "N",
            //   packing_type: "1",
            //   truck_size: "9mt",
            rate_info: [],
          },
        ],
      }));
    }
  }, [myForm.pageState.pay_type]);

  useEffect(() => {
    const getDDRate = async () => {
      const url = SERVER_URL + "/party_rate/get_dd_fix";

      const dataToSend = {
        station_from: myForm.pageState.station_from,
        consignor_id: myForm.pageState.consignor_id,
        consignee_id: myForm.pageState.consignee_id,
        station_to: myForm.pageState.station_to,
      };

      const resp = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (resp.ok) {
        const respData = await resp.json();
        if ("amount" in respData) {
          myForm.setPageState((oldState) => ({
            ...oldState,
            door_del_charge: respData.amount,
            delivery_dest_type: "1",
          }));
        }
      }
    };

    if (myForm.pageMode == "write") {
      getDDRate();
    }
  }, [
    myForm.pageState.consignor_id,
    myForm.pageState.station_from,
    myForm.pageState.station_to,
    myForm.pageState.consignee_id,
  ]);

  const getAdditionalInfoForTransporterFetch = () => {
    let additionalInfoObject = {
      is_transporter: 1,
    };
    return additionalInfoObject;
  };

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    let additionalInfoObject = {};
    if (fieldInfoObject.name == "consignor_name") {
      additionalInfoObject.branch_id = myForm.pageState.created_from;
      additionalInfoObject.bilty_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    if (fieldInfoObject.name == "consignee_name") {
      // additionalInfoObject.branch_id = myForm.pageState.created_from;
      additionalInfoObject.pay_type = myForm.pageState.pay_type;
      if (
        myForm.pageState.pay_type == "1" ||
        myForm.pageState.pay_type == "4"
      ) {
        additionalInfoObject.station_from = parseInt(
          myForm.pageState.station_from
        );
        additionalInfoObject.station_to = myForm.pageState.station_to;
      }
      return additionalInfoObject;
    }
    if (fieldInfoObject.name == "consignor_gst") {
      additionalInfoObject.branch_id = myForm.pageState.created_from;
      additionalInfoObject.bilty_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    if (fieldInfoObject.name == "consignee_gst") {
      // additionalInfoObject.branch_id = myForm.pageState.created_from;
      additionalInfoObject.pay_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    if (fieldInfoObject.name == "station_from_name") {
      additionalInfoObject.is_branch = 0; // changed from true to 0
      // additionalInfoObject.pay_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    if (fieldInfoObject.name == "billing_party_name") {
      additionalInfoObject.is_account_related = "1";
      // additionalInfoObject.pay_type = myForm.pageState.pay_type;
      return additionalInfoObject;
    }
    return null;
  };

  const checkVisibilityCondition = (fieldInfo) => {
    if (
      (fieldInfo.name === "from_pincode" || 
      fieldInfo.name === "from_zone" || 
      fieldInfo.name === "to_pincode" || 
      fieldInfo.name === "to_zone") &&
      (myForm.pageState.type_of_shipping !== 1 || myForm.pageState.is_wipro !== true)
    ) {
      return false;
    }

    if (fieldInfo.name == "edit_button") {
      const roleId = String(sessionObject.sessionVariables.role_id);
      if (
        roleId != "1" &&
        roleId != "2" &&
        (myForm.pageState.pay_type == 1 || myForm.pageState.pay_type == 4) &&
        String(myForm.pageState.booking_chalan_no) != ""
      ) {
        return "";
      }
    }
    if (
      fieldInfo.name == "delete_button" &&
      myForm.pageState.role_id != "1" &&
      myForm.pageState.role_id != "2"
    ) {
      return false;
    } else if (
      myForm.pageState.pay_type == "2" &&
      fieldInfo.name == "delete_button" &&
      myForm.pageState.role_id != "1"
    ) {
      return false;
    } else if (
      myForm.pageState.mr_no != "" &&
      fieldInfo.name == "delete_button" &&
      myForm.pageState.role_id != "1"
    ) {
      return false;
    } else if (
      myForm.pageState.pay_type == "2" &&
      fieldInfo.name == "edit_button" &&
      myForm.pageState.role_id != "1"
    ) {
      return false;
    } else if (
      myForm.pageState.mr_no != "" &&
      fieldInfo.name == "edit_button" &&
      myForm.pageState.role_id != "1"
    ) {
      return false;
    } else if (
      myForm.pageState.is_crossing == "N" &&
      fieldInfo.name == "transporter_name"
    ) {
      return false;
    } else if (
      myForm.pageState.is_crossing == "n" &&
      fieldInfo.name == "transporter_name"
    ) {
      return false;
    } /*else if (
    //   myForm.pageState.pay_type != "4" &&
    //   fieldInfo.name == "billing_party_name"
    // ) {
    //   return false;
    // } */ else if (
      myForm.pageState.is_crossing == "" &&
      fieldInfo.name == "transporter_name"
    ) {
      return false;
    } else if (
      myForm.pageState.is_crossing == "N" &&
      fieldInfo.name == "transporter_freight"
    ) {
      return false;
    } else if (
      myForm.pageState.is_crossing == "n" &&
      fieldInfo.name == "transporter_freight"
    ) {
      return false;
    } else if (
      myForm.pageState.is_crossing == "Y" &&
      fieldInfo.name == "bilty_charge"
    ) {
      return false;
    } else if (
      myForm.pageState.is_crossing == "" &&
      fieldInfo.name == "transporter_freight"
    ) {
      return false;
    } else if (fieldInfo.name == "consignee2_name" && 
    parseInt(process.env.REACT_APP_USE_CONSIGNEE_2) == 0
    ) {
      return false;
    } else if (fieldInfo.name == "consignee2_gst" && 
    parseInt(process.env.REACT_APP_USE_CONSIGNEE_2) == 0
    ) {
      return false;
    } else if (fieldInfo.name == "actual_weight") {
      return false;
    } else {
      return true;
    }
  };

  const checkDisabledCondition = (fieldInfo) => {
    if (myForm.pageMode == "view") {
      return "disabled";
    } else if (
      fieldInfo.name == "pay_type" &&
      myForm.pageState.pay_type == "4" &&
      myForm.pageState.item_in[0].item_name != "" &&
      myForm.pageMode != "write" &&
      parseInt(process.env.REACT_APP_BILTY_DISABLE_DYNAMIC_TABLE_IN_TBB_MODIFY)
    ) {
      return "disabled";
    } else if (myForm.pageMode == "edit" && fieldInfo.name == "input_date") {
      return "";
    } else {
      return "";
    }
  };

  const fetchChargeRate = async () => {
    let packages = 0;
    let total_weight = 0;
    for (var data of myForm.pageState["item_in"]) {
      packages = packages + (parseInt(data.pkgs) || 0);
      total_weight = total_weight + (parseFloat(data.weight) || 0);
    }
    // if (myForm.pageState["Bilty No"] == "" && e.key == "Enter") {
    //   myForm.makeFocusOnParticularField("delivery_on");
    //   return;
    // }
    // if (e.key == "Enter") {
    //   let flag = 0;
    //   if (
    //     myForm.pageState.bilty_type == "c" ||
    //     myForm.pageState.bilty_type == "C"
    //   ) {
    //     flag = 1;
    //   }
    //   let suffix = myForm.pageState.suffix;
    //   if (suffix == "") {
    //     suffix = "null";
    //   }
    const url = SERVER_URL + "/charge_rate/get";
    // + "?fyear=" + myForm.pageState.fYear + "&companyId=" + myForm.pageState.company_id;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        bilty_type: myForm.pageState.pay_type,
        station_from: myForm.pageState.station_from,
        station_to: myForm.pageState.station_to,
        consignor_id: myForm.pageState.consignor_id,
        consignee_id: myForm.pageState.consignee_id,
      }),
    });

    console.log("Response", response);
    const temp_response = await response.json();
    if (temp_response.length == 0) {
      return;
    }

    let dummyObject = {
      bilty_charge: myForm.pageState.bilty_charge,
      hamali: myForm.pageState.hamali,
      door_del_charge: myForm.pageState.door_del_charge,
      lc_charge:myForm.pageState.lc_charge,
      oda_charge:myForm.pageState.oda_charge,
      labour_charge:myForm.pageState.labour_charge,
      unloading_charge:myForm.pageState.unloading_charge,
      pop_charge:myForm.pageState.pop_charge,
      detenstion_charge:myForm.pageState.detenstion_charge,
      return_charge:myForm.pageState.return_charge,
      csd_charge:myForm.pageState.csd_charge,
      dk_charge:myForm.pageState.dk_charge,
      normal_bilty_charge: "",
      normal_hamali: "",
      normal_door_del_charge: "",
      normal_lc_charge: "",
      normal_oda_charge: "",
      normal_labour_charge :"",
      normal_unloading_charge: "",
      noraml_pop_charge: "",
      normal_detenstion_charge: "",
      normal_return_charge:"",
      normal_csd_charge :"",
      normal_dk_charge : "",
    };
    for (var info of temp_response.charge_info) {
      console.log("Info begin :-", info);
      if (info.charge_type == 1) {
        if (info.charge == 1) {
          // if(dummyObject){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
          } else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.bilty_charge = info.amount;
            }
          } else if (
            total_weight >= info.qty_from_kg &&
            total_weight <= info.qty_to_kg
          ) {
            dummyObject.bilty_charge = info.amount;
          }
          if (dummyObject.bilty_charge == "") {
            if (info.qty_from_case == null && info.qty_to_case == null) {
            } else if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.bilty_charge = info.amount;
              }
            } else if (
              packages >= info.qty_from_case &&
              packages <= info.qty_to_case
            ) {
              dummyObject.bilty_charge = info.amount;
            }
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.normal_bilty_charge = info.amount;
          }

          if (dummyObject.bilty_charge == "") {
            dummyObject.bilty_charge = 0;
          }
        } else if (info.charge == 2) {
          console.log(
            "Unit :- ",
            myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1][
              "unit"
            ]
          );
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.oda_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.oda_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.oda_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.oda_charge = info.amount;
          }
        
          if (dummyObject.oda_charge == null) {
            dummyObject.oda_charge = info.amount;
          }
          
          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.oda_charge = info.amount;
          }

          if (dummyObject.oda_charge == null) {
            dummyObject.oda_charge = 0;
          }
        } else if (info.charge == 3) {
         
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.labour_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.labour_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.labour_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.labour_charge = info.amount;
          }
        
          if (dummyObject.labour_charge == null) {
            dummyObject.labour_charge = info.amount;
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.labour_charge = info.amount;
          }          
        
          if (dummyObject.labour_charge == null) {
            dummyObject.labour_charge = 0;
          }
        } else if (info.charge == 4) {
          
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.unloading_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.unloading_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.unloading_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.unloading_charge = info.amount;
          }
        
          if (dummyObject.unloading_charge == null) {
            dummyObject.unloading_charge = info.amount;
          }
          
          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.unloading_charge = info.amount;
          }  

          if (dummyObject.unloading_charge == null) {
            dummyObject.unloading_charge = 0;
          }
        } else if (info.charge == 5) {
          
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.pop_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.pop_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.pop_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.pop_charge = info.amount;
          }
        
          if (dummyObject.pop_charge == null) {
            dummyObject.pop_charge = info.amount;
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.pop_charge = info.amount;
          } 
        
          if (dummyObject.pop_charge == null) {
            dummyObject.pop_charge = 0;
          }
        } else if (info.charge == 6) {
          
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.detenstion_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.detenstion_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.detenstion_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.detenstion_charge = info.amount;
          }
        
          if (dummyObject.detenstion_charge == null) {
            dummyObject.detenstion_charge = info.amount;
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.detenstion_charge = info.amount;
          } 
        
          if (dummyObject.detenstion_charge == null) {
            dummyObject.detenstion_charge = 0;
          }
        } else if (info.charge == 7) {
          
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.return_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.return_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.return_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.return_charge = info.amount;
          }
        
          if (dummyObject.return_charge == null) {
            dummyObject.return_charge = info.amount;
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.return_charge = info.amount;
          } 
        
          if (dummyObject.return_charge == null) {
            dummyObject.return_charge = 0;
          }
        } else if (info.charge == 8) {
          
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.csd_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.csd_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.csd_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.csd_charge = info.amount;
          }
        
          if (dummyObject.csd_charge == null) {
            dummyObject.csd_charge = info.amount;
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.csd_charge = info.amount;
          } 
        
          if (dummyObject.csd_charge == null) {
            dummyObject.csd_charge = 0;
          }
        } else if (info.charge == 9) {
          
          // if(myForm.pageState["item_in"][myForm.pageState["item_in"].length - 1]['unit'] == 'W'){
          if (info.qty_from_kg == null && info.qty_to_kg == null) {
            if (info.qty_from_case != null && info.qty_to_case == null) {
              if (packages >= info.qty_from_case) {
                dummyObject.dk_charge = info.amount;
              }
            } else if (packages >= info.qty_from_case && packages <= info.qty_to_case) {
              dummyObject.dk_charge = info.amount;
            }
          }
          else if (info.qty_from_kg != null && info.qty_to_kg == null) {
            if (total_weight >= info.qty_from_kg) {
              dummyObject.dk_charge = info.amount;
            }
          } else if (total_weight >= info.qty_from_kg && total_weight <= info.qty_to_kg) {
            dummyObject.dk_charge = info.amount;
          }
        
          if (dummyObject.dk_charge == null) {
            dummyObject.dk_charge = info.amount;
          }

          if (
            info.qty_from_case == null &&
            info.qty_to_case == null &&
            info.qty_from_kg == null &&
            info.qty_to_kg == null
          ) {
            dummyObject.dk_charge = info.amount;
          } 
        
          if (dummyObject.dk_charge == null) {
            dummyObject.dk_charge = 0;
          }
        }
      } else if (info.charge_type == 3) {
        if (info.charge == 1) {
          dummyObject.bilty_charge = info.amount * packages;
        } else if (info.charge == 2) {
          dummyObject.door_del_charge = info.amount * packages;
        } else if (info.charge == 4) {
          dummyObject.hamali = info.amount * packages;
        }
      } else if (info.charge_type == 4) {
        if (info.charge == 1) {
          dummyObject.bilty_charge = info.amount * total_weight;
        } else if (info.charge == 2) {
          dummyObject.door_del_charge = info.amount * total_weight;
        } else if (info.charge == 4) {
          dummyObject.hamali = info.amount * total_weight;
        }else if(info.charge == 3){
          dummyObject.lc_charge = info.amount * total_weight;
        }
      }
    }
    if (
      dummyObject.bilty_charge == "" &&
      dummyObject.normal_bilty_charge != ""
    ) {
      dummyObject.bilty_charge = dummyObject.normal_bilty_charge;
    }
    if (dummyObject.hamali == "" && dummyObject.normal_hamali != "") {
      dummyObject.hamali = dummyObject.normal_hamali;
    }
    console.log("Door dele charge :- ", dummyObject.normal_door_del_charge);
    if (
      dummyObject.door_del_charge == "" &&
      dummyObject.normal_door_del_charge != ""
    ) {
      dummyObject.door_del_charge = dummyObject.normal_door_del_charge;
    }
    let objectToSave = {
      bilty_charge: dummyObject.bilty_charge,
      hamali: dummyObject.hamali,
      door_del_charge: dummyObject.door_del_charge,
      lc_charge:dummyObject.lc_charge,
      oda_charge:dummyObject.oda_charge,
      labour_charge:dummyObject.labour_charge,
      unloading_charge:dummyObject.unloading_charge,
      pop_charge:dummyObject.pop_charge,
      detenstion_charge:dummyObject.detenstion_charge,
      return_charge:dummyObject.return_charge,
      csd_charge:dummyObject.csd_charge,
      dk_charge:dummyObject.dk_charge,
    };

    //   if (!response.ok) {
    myForm.setPageState({
      ...myForm.pageState,
      ...objectToSave,
    });
    
    //     const temp_error = await response.json();
    //     if ("detail" in temp_error){
    //       myForm.setPageMode("error");
    //       myForm.setPopupError(temp_error.detail);
    //     }
    //     else{
    //       myForm.setPageMode("error");
    //       myForm.setPopupError("Invalid Bilty");
    //     }
    //     return;
    //   }
    //   const temp_response = await response.json();
    //   if (temp_response.check_fail) {
    //     myForm.setPageState({
    //       ...myForm.pageState,
    //       ["Bilty No"]: "",
    //     });
    //     myForm.setPageMode("error");
    //     myForm.setPopupError("Not possible to add this bilty");
    //     return;
    //   }
    //   if (
    //     checkIfFieldAlreadyExists(
    //       "bilty_id",
    //       temp_response.bilty_id,
    //       myForm.pageState.bilty_ids
    //     )
    //   ) {
    //     myForm.setPageState({
    //       ...myForm.pageState,
    //       ["No"]: "",
    //     });
    //     myForm.setPageMode("error");
    //     myForm.setPopupError("Already present");
    //     return;
    //   }

    //   let partyName = "";
    //   let total_amount = 0;
    //   let newState = {
    //     bilty_ids: [...myForm.pageState["bilty_ids"], temp_response],
    //     ["Bilty No"]: "",
    //   };
    //   if (myForm.pageState.bilty_ids.length == 0) {
    //     partyName = temp_response.consignee_name;
    //   }
    //   if (partyName != "") {
    //     newState.party_name = partyName;
    //   }
    //   if (temp_response.pay_type_name == "To Pay") {
    //     if (temp_response.freight != "" && temp_response.freight != null) {
    //       total_amount += parseInt(temp_response.freight);
    //     }
    //     if (temp_response.hamali != "" && temp_response.hamali != null) {
    //       total_amount += parseInt(temp_response.hamali);
    //     }
    //     if (
    //       temp_response.door_del_charge != "" &&
    //       temp_response.door_del_charge != null
    //     ) {
    //       total_amount += parseInt(temp_response.door_del_charge);
    //     }
    //     if (
    //       temp_response.bilty_charge != "" &&
    //       temp_response.bilty_charge != null
    //     ) {
    //       total_amount += parseInt(temp_response.bilty_charge);
    //     }
    //     if (
    //       temp_response.other_amount != "" &&
    //       temp_response.other_amount != null
    //     ) {
    //       total_amount += parseInt(temp_response.other_amount);
    //     }

    //     if (
    //       myForm.pageState.to_pay_amount != "" &&
    //       myForm.pageState.to_pay_amount != null
    //     ) {
    //       newState.to_pay_amount = String(
    //         total_amount + parseInt(myForm.pageState.to_pay_amount)
    //       );
    //     } else {
    //       newState.to_pay_amount = String(total_amount);
    //     }
    //   }
    //   console.log("New state", newState);
    //   myForm.setPageState({
    //     ...myForm.pageState,
    //     ...newState,
    //   });
      myForm.makeFocusOnParticularField("charge_weight");
    // }
  };

  const handleAccountDetails = async () => {
      const no_bilty = parseInt(myForm.pageState.bilty_no)
      console.log("TYPE CHECKKKKKKKKK",typeof(no_bilty),typeof(myForm.pageState.fYear))
      const url = SERVER_URL + `/bilty/get_account_details/?module=bilty&bilty_no=${no_bilty}&fyear=${myForm.pageState.fYear}`
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
    
        if (!response.ok) {
          throw new Error("Error fetching print data");
        }
        // debugger
        const data = await response.json();
        let dataNew = []
        for (let i=0;i<data.length;i+=2){
          // debugger
          console.log("DFFFFFFFFFFFF",data[i].data.credit,data[i].data.debit,data[i].source_party_data.name,data[i].other_party_data.name)
          const temp_data = {
            // credit:data[i].data.credit,
            debit:data[i].data.debit,
            voucher_id:data[i].data.voucher_id,
            voucher_type:data[i].data.voucher_type,
            source_party_name:data[i].source_party_data.name,
            party_name:data[i].other_party_data.name,
            remarks:data[i].data.remarks
          }
          dataNew.push(temp_data)
          // dataNew.push(data[i].data.credit)
          // dataNew.push(data[i].data.debit)
          // dataNew.push(data[i].source_party_data.name)
          // dataNew.push(data[i].other_party_data.name)
        }
        // debugger
        setPrintData(dataNew);
        setPopupLoading(false);
      } catch (error) {
        console.error("Error fetching print data:", error);
        // Handle the error state here
      }
      
    
  }

  const handlePaidAmount = async () => {
    const fYear_fetch = JSON.parse(
      sessionStorage.getItem("financial_year_for_fetch")
    ).financial_year_for_fetch;

    const url =
      SERVER_URL +
      "/bilty/paid_clear?branch_id=" +
      myForm.pageState.created_from +
      "&user_id=" +
      myForm.pageState.created_by +
      "&fyear=" +
      myForm.pageState.fYear +
      "&companyId=" +
      myForm.pageState.company_id;

    const response = await fetch(url, { method: "POST" });
    if (!response.ok) {
      console.log("Not able to delete bilty");
      return;
    }
    const temp_response = await response.json();
    // myForm.pageState.paid_amount = 0;
    let objToSave = {
      paid_amount: 0,
    };
    myForm.setPageState({
      ...myForm.pageState,
      ...objToSave,
    });
    // myForm.setPageState({ ...dataObject});
    // if (temp_response.is_deleted) {
    //   myForm.setPageState({ ...dataObject, ...variablesFromSession });
    //   myForm.setPageMode("write");
    //   window.location.reload();
    //   return;
    // }
  };

  const handleDelete = async () => {
    let url = SERVER_URL + "/bilty/hard/?bilty_id=" + myForm.pageState.bilty_id;

    // url += "&fyear=" + myForm.pageState.fYear + "&companyId=" + myForm.pageState.company_id;

    const response = await fetch(url, { method: "DELETE" });
    if (!response.ok) {
      console.log("Not able to delete bilty");
      return;
    }
    const temp_response = await response.json();
    if (temp_response.is_deleted) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
      return;
    }
  };

  const checkPrint = async () => {
    console.log("Ho");
    // throw new Error("Check");
    let response = null;
    try {
      response = await myForm.synchronousSave();
      myForm.setPageState({
        ...myForm.pageState,
        ...response.response,
      });
      myForm.setPageMode("submitted");
    } catch (e) {
      if ("save_button" in myForm.refStoreObject.current) {
        myForm.refStoreObject.current["save_button"].removeAttribute(
          "disabled"
        );
      }
      if ("print_button" in myForm.refStoreObject.current) {
        myForm.refStoreObject.current["print_button"].removeAttribute(
          "disabled"
        );
      }
      myForm.setPreviousPageMode(myForm.pageMode);
      myForm.setPageMode("error");
      myForm.setPopupError(e.message);
      throw new Error("Hiiii");
    }

    console.log("response sync", response);
    return;
  };

  const handleShippingType = (e) => {
    const value = e.target.value;
    setSelectedType(value);
    if (value === 'FTL') {
      myForm.setPageState((olState) => ({
        ...olState,
        item_in: [
          {
            ...myForm.pageState.item_in[0],
            rate: "",
            amount: "",
            //   item_name: "",
            //   pkgs: "",
            //   rate: "",
              unit: "F",
            //   weight: "",
            //   new_row: "N",
            //   packing_type: "1",
            //   truck_size: "9mt",
            rate_info: [],
          },
        ],
      }));
    } else {
      myForm.setPageState((olState) => ({
        ...olState,
        item_in: [
          {
            ...myForm.pageState.item_in[0],
            rate: "",
            amount: "",
            //   item_name: "",
            //   pkgs: "",
            //   rate: "",
              unit: "W",
            //   weight: "",
            //   new_row: "N",
            //   packing_type: "1",
            //   truck_size: "9mt",
            rate_info: [],
          },
        ],
      }));
    }
    myForm.makeFocusOnParticularField("bilty_no");
  };


  const handleVolumetricWeight = (e) => {
    setWeightMode(e.target.value);
    myForm.makeFocusOnParticularField("bilty_no");
  }

  const handleTransportMode = (e) => {
    setTransportMode(e.target.value);
    myForm.makeFocusOnParticularField("bilty_no");

  };


  const transporterFieldInfo = {
    label: "Transporter",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "transporter_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getTransporterSuggestions",
    url: SERVER_URL + "/transporter/",
    suggestionKeyword: "transporter_name",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "transporter_id",
    suggestionSchema: {
      transporter_name: "transporter_name",
      suffix: "suffix",
      transporter_id: "transporter_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
      Enter: "bilty_no",
    },
    valueVerificationFromSuggestionNeeded: true,
    valueVerificationCompulsionField: "transporter_id",
  };

  return (
    <div className="form-container">
      {USE_OVERLAY && (
        <LoadingOverlay
          active={myForm.overlay}
          spinner
          text="Loading your content..."
          styles={{
            wrapper: {
              // width: '400px',
              // height: '400px',
              overflow: true ? "hidden" : "scroll",
            },
          }}
        ></LoadingOverlay>
      )}

      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          // open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          open={myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>{popupInfo.success_header}</div>
                ) : (
                  <div>{popupInfo.error_header}</div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {popupInfo.success_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_success}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.pageState[popupInfo.field_name_success]}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {popupInfo.error_title}
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">
                        {popupInfo.field_label_error}
                      </div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      if (myForm.previousPageMode != "") {
                        myForm.setPageMode(myForm.previousPageMode);
                        myForm.setPreviousPageMode("");
                      } else {
                        myForm.setPageMode("write");
                      }
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.deletePopup}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">Are you sure want to delete?</div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    handleDelete();
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  Yes
                </button>
                <button
                  className="pop-up-button"
                  onClick={() => {
                    myForm.setDeletePopup(false);
                    close();
                  }}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div className="form-parent">
        {process.env.REACT_APP_CLIENT_NAME == "CHAMUNDA LOGISTICS" && <button onClick={()=> {handleAccountDetails(), setIsPrint(true)}}>Account Details</button>}


        <div>
        <Popup
            open = {isPrint}
            modal
            closeOnDocumentClick={false}
        >
              {(close) => (
                <div className="pop-up-container">
                  <div className="pop-up-header">
                    {popupLoading ? (
                      <div>Loading...</div>
                    ) : (
                      <>
                        <DynamicViewTable
                          checkBox={0}
                          tableHeader={accountDetailTableHeader}
                          tableItems={accountDetailTableItems}
                          tableValues={printData}
                          // setPageStateByField={myForm.setPageStateByField}
                          pageStateArray={printData}
                          // deleteEntryFromTableCallback={deleteEntryFromTableCallback}
                          handleCheckboxChange={handleCheckboxChangeRR}
                          fieldMapping="bilty_ids"
                          getSelectAllValue={getSelectAllValueRR}
                          selectAll={selectAllRR}
                          deselectAll={deselectAllRR}
                        />
                      </>
                    )}
                  </div>

                <div className="rr-pop-up-actions">
                  <button
                    className="pop-up-button"
                    id="yes_button"
                    onClick={() => {
                        setIsPrint(false);
                        close();
                    }}
                  >
                    Close
                  </button>
                  {/* <button
                    className="pop-up-button"
                    id="yes_button"
                    onClick={() => {
                        setIsPrint(false);
                        setIsStopRR(true);
                        close();
                    }}
                  >
                    Stop
                  </button> */}
                  <button
                    type="button"
                    className="pop-up-button"
                  >
                    Print
                  </button>
                        {/* <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-primary"
                            table="account_report_excel_bilty"
                            filename="account_without_bilty"
                            sheet="tablexls"
                            buttonText="Download"
                          />
                          {ReportExcel.account_without_bilty_excel(
                            printData
                          )} */}
                </div>
                </div>
              )}

        </Popup>
      </div>



        <div className="shipping-type-container">
          <div className="shipping-type-label">Shipping Type:</div>
          <div className="radio-buttons">
            <label>
              <input
                type="radio"
                value="FTL"
                // checked={selectedType === 'FTL'}
                checked={myForm.pageState?.type_of_shipping === 1}
                disabled={myForm.pageMode === "edit"}
                onChange={handleShippingType}
              />
              FTL
            </label>
            <label>
              <input
                type="radio"
                value="PTL"
                // checked={selectedType === 'PTL'}
                checked={myForm.pageState?.type_of_shipping === 2}
                disabled={myForm.pageMode === "edit"}
                onChange={handleShippingType}
              />
              PTL
            </label>
          </div>
        </div>


        <div className="shipping-type-container">
          <div className="transportation-mode-label">Transportation Mode:</div>
          <div className="radio-buttons">
            <label>
              <input
                type="radio"
                value="Rail"
                // checked={transportMode === 'Rail'}
                checked={myForm.pageState?.mode_of_transportation === 4}
                disabled={myForm.pageMode === "edit"}
                onChange={handleTransportMode}
              />
              Rail
            </label>
            <label>
              <input
                type="radio"
                value="Road"
                // checked={transportMode === 'Road'}
                checked={myForm.pageState?.mode_of_transportation === 3}
                disabled={myForm.pageMode === "edit"}
                onChange={handleTransportMode}
              />
              Road
            </label>
            <label>
              <input
                type="radio"
                value="Ship"
                // checked={transportMode === 'Ship'}
                checked={myForm.pageState?.mode_of_transportation === 5}
                disabled={myForm.pageMode === "edit"}
                onChange={handleTransportMode}
              />
              Ship
            </label>
            <label>
              <input
                type="radio"
                value="Air"
                // checked={transportMode === 'Air'}
                checked={myForm.pageState?.mode_of_transportation === 6}
                disabled={myForm.pageMode === "edit"}
                onChange={handleTransportMode}
              />
              Air
            </label>
          </div>
        </div>

        <div className="shipping-type-container">
          {/* {myForm.pageState.type_of_shipping !== 1  && ( */}
            <div className="shipping-type-container">
              <div className="volume-weight-label">Volumetric Weight:</div>
              <div className="radio-buttons">
                <label>
                  <input
                    type="radio"
                    value="CFT"
                    // checked={weightMode === 'CFT'}
                    checked={myForm.pageState?.type_of_weight === 11}
                    disabled={myForm.pageMode === "edit"}
                    onChange={handleVolumetricWeight}
                  />
                  CFT
                </label>
                <label>
                  <input
                    type="radio"
                    value="LBH"
                    // checked={weightMode === 'LBH'}
                    checked={myForm.pageState?.type_of_weight === 12}
                    disabled={myForm.pageMode === "edit"}
                    onChange={handleVolumetricWeight}
                  />
                  LBH
                </label>
                <label>
                  <input
                    type="radio"
                    value="Normal"
                    // checked={weightMode === 'LBH'}
                    checked={myForm.pageState?.type_of_weight === 13}
                    disabled={myForm.pageMode === "edit"}
                    onChange={handleVolumetricWeight}
                  />
                  Normal
                </label>
                <label>
                  <input
                    type="radio"
                    value="Liter"
                    // checked={weightMode === 'LBH'}
                    checked={myForm.pageState?.type_of_weight === 14}
                    disabled={myForm.pageMode === "edit"}
                    onChange={handleVolumetricWeight}
                  />
                  Litre
                </label>
                <label>
                  <input
                    type="radio"
                    value="FTL"
                    checked={myForm.pageState?.type_of_weight === 15}
                    disabled={myForm.pageMode === "edit"}
                    onChange={handleVolumetricWeight}
                  />
                  FTL
                </label>

              </div>
            </div>
          {/* )} */}
        </div>

        {myForm.pageState.type_of_shipping === 1 && (
          <div className="shipping-type-container">
            <div className="wipro-label">Is Wipro?</div>
            <div className="radio-buttons">
              <label>
                <input
                  type="radio"
                  value="Yes"
                  checked={myForm.pageState?.is_wipro === true}
                  disabled={myForm.pageMode === "edit"}
                  onChange={() =>
                    myForm.setPageState((prev) => ({ ...prev, is_wipro: true }))
                  }
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  value="No"
                  checked={myForm.pageState?.is_wipro === false}
                  disabled={myForm.pageMode === "edit"}
                  onChange={() =>
                    myForm.setPageState((prev) => ({ ...prev, is_wipro: false }))
                  }
                />
                No
              </label>
            </div>
          </div>
        )}
        

        <div className="form-header-bilty">
          <div style={{marginLeft: "150px"}}>
            Docket
          </div>
        </div>
        {/* <div className="form-side">Paid Amount:</div>
        <div className="form-al">{myForm.pageState.paid_amount}</div> */}
        {/* <button class="clear-button" onClick={handlePaidAmount}>
          Clear
        </button> */}
        <div style={{marginLeft: "100px"}}>
          <Popup
            open={podOpen}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            <div className="pop-up-container">
              <div className="pop-up-header">Upload POD</div>
              <button
                class="clear-button"
                disabled={!myForm.pageState.bilty_id}
                onClick={() => {
                  history.push(
                    `/add-photo?bilty_id=${myForm.pageState.bilty_id}`
                  );
                }}
              >
                Open Camera
              </button>
              <button onClick={handleImageUpload}>Choose File</button>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    setPodOpen(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </Popup>
          <Popup
            open={podUploadPopup.open}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            <div className="pop-up-container">
              <div className="pop-up-header">{podUploadPopup.header}</div>
              <div className="pop-up-content">{podUploadPopup.message}</div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() =>
                    setPodUploadPopup({
                      open: false,
                      header: "",
                      message: "",
                    })
                  }
                >
                  Okay
                </button>
              </div>
            </div>
          </Popup>
          <button
            class="clear-button"
            disabled={!myForm.pageState.bilty_id}
            onClick={showFlagPod}
          >
            Upload POD
          </button>
          <button
            class="clear-button"
            disabled={!myForm.pageState.bilty_id || isPodButtonDisabled}
            onClick={handleDownloadPod}
          >
            Download POD
          </button>

          <Popup
            open={podImageOpen}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            <div className="pop-up-container">
              <div className="pop-up-header">POD Image</div>
              <div className="pod-img-container">
                {imageUrl && (
                  <img
                    className="pod-img"
                    src={imageUrl}
                    alt="Preview"
                    style={{
                      transform: `rotate(${rotationAngle}deg)`,
                      width: rotationAngle % 180 === 0 ? "100%" : "55%",
                    }}
                  />
                )}
              </div>
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => setPodImageOpen(false)}
                >
                  Close
                </button>
                <button onClick={handleRotate} className="pop-up-button">
                  Rotate
                </button>
              </div>
            </div>
          </Popup>
          <button
            class="clear-button"
            onClick={() => setPodImageOpen(true)}
            disabled={!myForm.pageState.bilty_id || isPodButtonDisabled}
          >
            Preview
          </button>
        </div>
        
      </div>
      <div className="form">
        <div className="form-title">
          {(process.env.REACT_APP_CLIENT !== "shubham" && process.env.REACT_APP_CLIENT !== "sra") && <div className="form-row">
            <label className="form-label">Crossing?</label>
            <select
              className="form-input"
              onChange={(newValue) => {
                myForm.handleChangeForSelect(newValue, "is_crossing");
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "is_crossing")}
              disabled={checkDisabledCondition({ name: "is_crossing" })}
              value={myForm.pageState["is_crossing"]}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  a.preventDefault();
                  if (
                    myForm.pageState.is_crossing == "N" ||
                    myForm.pageState.is_crossing == "n"
                  ) {
                    myForm.makeFocusOnParticularField("bilty_no");
                    return;
                  } else {
                    myForm.makeFocusOnParticularField("transporter_name");
                    return;
                  }
                }
              }}
            >
              <option value="N" key="N">
                N
              </option>
              <option value="Y" key="Y">
                Y
              </option>
            </select>
          </div>}
          <div className="form-row">
            {checkVisibilityCondition(transporterFieldInfo) && (
              <label className="form-label">Transprter Name</label>
            )}
            {checkVisibilityCondition(transporterFieldInfo) && (
              <Autosuggest
                id={transporterFieldInfo["name"]}
                // suggestions={myForm.suggestions}
                suggestions={
                  myForm.suggestions != undefined ? myForm.suggestions : ""
                } // changes made for removing error that was caused by undefined suggestion
                onSuggestionsFetchRequested={(a) =>
                  myForm.onSuggestionsFetchRequested(a, (b) =>
                    myForm.suggestionFetchApi(
                      transporterFieldInfo,
                      b,
                      getAdditionalInfoForTransporterFetch()
                    )
                  )
                }
                onSuggestionsClearRequested={() =>
                  myForm.onSuggestionsClearRequested(transporterFieldInfo)
                }
                getSuggestionValue={(suggestion) =>
                  suggestion[transporterFieldInfo.suggestionKeyword]
                }
                onSuggestionSelected={(a, b) =>
                  myForm.getSuggestionValue(
                    b.suggestion,
                    transporterFieldInfo,
                    myForm.performSuggestions,
                    myForm.updatePageStateForGetSuggestion
                  )
                }
                renderSuggestion={(a) =>
                  myForm.renderSuggestion(a, transporterFieldInfo)
                }
                highlightFirstSuggestion={true}
                ref={(a) => myForm.storeInputReference(a, false)}
                inputProps={{
                  //placeholder: info["name"],
                  value: String(myForm.pageState[transporterFieldInfo["name"]]),
                  onChange: (a, b) => {
                    myForm.onChangeAutoSuggest(a, b, transporterFieldInfo);
                  },
                  onBlur: () => {
                    transporterFieldInfo["toValidate"]
                      ? myForm.onblurValidator(transporterFieldInfo)
                      : {};
                  },
                  onKeyPress: (a) => {
                    if (a.key == "Enter") {
                      myForm.makeFocusOnParticularField("bilty_no");
                    }
                  },
                  disabled: checkDisabledCondition(transporterFieldInfo),
                }}
              />
            )}
          </div>
          <div className="form-row">
            <label className="form-label">Docket No:</label>
            <input
              id="size"
              className="form-input"
              type="text"
              name="bilty_no"
              placeholder=""
              value={myForm.pageState.bilty_no}
              // onChange={myForm.handleChange}
              onChange={(e) => {
                const upperCaseValue = e.target.value.toUpperCase();
                myForm.handleChange({ target: { name: "bilty_no", value: upperCaseValue } });
              }}
              onBlur={() => {validate}}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.bilty_no)
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "bilty_no")}
              disabled={checkDisabledCondition({ name: "bilty_no" })}
            />
            <input
              className="form-input-suffix"
              type="text"
              name="suffix"
              placeholder=""
              value={myForm.pageState.suffix}
              onChange={myForm.handleChange}
              onBlur={() => {}}
              onKeyPress={(a) =>
                myForm.getPageOnKeyEnter(a, myForm.pageState.bilty_no)
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "suffix")}
              //   disabled={true}
            />
            <p>{myForm.internalValidationErrors.bilty_no}</p>
            {myForm.pageMode == "view" && (
              <>
                {checkVisibilityCondition({ name: "edit_button" }) && (
                  <button
                    onClick={() => {
                      myForm.setPageMode("edit");
                    }}
                  >
                    Edit
                  </button>
                )}
                {/* <button
                  onClick={() => {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });
                    window.location.reload();
                    myForm.setPageMode("write");
                  }}
                >
                  Clear
                </button> */}
                {/* {checkVisibilityCondition({ name: "delete_button" }) && (
                  <button onClick={handleDelete}>Delete</button>
                )} */}
              </>
            )}
          </div>
          <div>
            Docket Date:
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={myForm.pageState.input_date}
              onChange={(date) =>
                myForm.setPageStateByField("input_date", date)
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              disabled={checkDisabledCondition({ name: "input_date" })}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  myForm.makeFocusOnParticularFieldForItem(
                    "eway_bill_no",
                    0,
                    "eway_bill_no"
                  );
                }
              }}
            />
          </div>
          {/* time field */}
          <div>
            <label>Time:</label>
            {}
            <input value={(myForm.pageState.input_date).toString().split(" ")[4]} disabled></input>
          </div>
          <div className="form-row">
            <label className="form-last_bilty"> Last Docket No: </label>
            <label className="form-last_bilty">
              {myForm.pageState.last_suffix != ""
                ? myForm.pageState.last_bilty_no +
                  "(" +
                  myForm.pageState.last_suffix +
                  ")"
                : myForm.pageState.last_bilty_no}
              {/* {myForm.pageState.last_bilty_no +
                "(" +
                myForm.pageState.last_suffix +
                ")"} */}
            </label>
          </div>
        </div>
        <div className="form-input-content-block-0">
          {process.env.REACT_APP_CLIENT !== "sra" && <div className="form-field-left-most responsive-table">
            <DynamicTable
              overlay={myForm.overlay}
              setOverlay={myForm.setOverlay}
              pageStateArray={myForm.pageState["eway_bill_no"]}
              pageMode={myForm.pageMode}
              fieldMapping="eway_bill_no"
              tableHeader={ewbTableHeader}
              tableItems={ewbTableItems}
              setPageStateByField={myForm.setPageStateByField}
              onSuggestionsFetchRequested={
                myForm.onSuggestionsFetchRequestedDebounced
              }
              onSuggestionsClearRequested={myForm.onSuggestionsClearRequested}
              onChangeAutoSuggest={myForm.onChangeAutoSuggest}
              getSuggestionValue={myForm.getSuggestionValue}
              renderSuggestion={myForm.renderSuggestion}
              performSuggestions={myForm.performSuggestions}
              // suggestions={myForm.suggestions}
              suggestions={
                myForm.suggestions != undefined ? myForm.suggestions : ""
              } // changes made for removing error that was caused by undefined suggestion
              suggestionFetchApi={myForm.suggestionFetchApi}
              storeInputReference={myForm.storeInputReference}
              refStoreObject={myForm.refStoreObject}
              makeFocusOnParticularField={myForm.makeFocusOnParticularField}
              makeFocusOnParticularFieldForItem={
                myForm.makeFocusOnParticularFieldForItem
              }
              apiConfig={biltyApiConfig["getEwbInfo"]}
              pageState={myForm.pageState}
              onblurValidatorForTable={myForm.onblurValidatorForTable}
              storeInputReferenceForSelectForDynamicTable={
                myForm.storeInputReferenceForSelectForDynamicTable
              }
            />
          </div>}
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
        </div>
        <div className="table-container responsive-table-container">
          <DynamicTable
            // overlay={myForm.overlay}
            weightMode={weightMode}
            setOverlay={myForm.setOverlay}
            pageStateArray={myForm.pageState["item_in"]}
            pageMode={myForm.pageMode}
            fieldMapping="item_in"
            tableHeader={itemTableHeader}
            tableItems={itemTableItems}
            setPageStateByField={myForm.setPageStateByField}
            onSuggestionsFetchRequested={
              myForm.onSuggestionsFetchRequestedDebounced
            }
            onSuggestionsClearRequested={myForm.onSuggestionsClearRequested}
            onChangeAutoSuggest={myForm.onChangeAutoSuggest}
            getSuggestionValue={myForm.getSuggestionValue}
            renderSuggestion={myForm.renderSuggestion}
            performSuggestions={myForm.performSuggestions}
            // suggestions={myForm.suggestions}
            suggestions={
              myForm.suggestions != undefined ? myForm.suggestions : ""
            } // changes made for removing error that was caused by undefined suggestion
            suggestionFetchApi={myForm.suggestionFetchApi}
            storeInputReference={myForm.storeInputReference}
            refStoreObject={myForm.refStoreObject}
            makeFocusOnParticularField={myForm.makeFocusOnParticularField}
            makeFocusOnParticularFieldForItem={
              myForm.makeFocusOnParticularFieldForItem
            }
            apiConfig={biltyApiConfig["getEwbInfo"]}
            pageState={myForm.pageState}
            fetchChargeRate={fetchChargeRate}
            onblurValidatorForTable={myForm.onblurValidatorForTable}
            storeInputReferenceForSelectForDynamicTable={
              myForm.storeInputReferenceForSelectForDynamicTable
            }
          />
          {/* <StaticTable/> */}
          <div className="form-field-vertical">
            {groupInfo[myForm.pageState.is_crossing === "Y" ? "group-5" : "group-3"]
              .filter(info => {

                if (
                  myForm.pageState.pay_type == "4" &&
                  (myForm.pageState.role_id !== "1" && myForm.pageState.role_id !== "2") 
                ) {
                  return false; 
                }
                return true;
              })
              .map(function (info) {
                if (info["type"] === "dropdown") {
                  return (
                    <div className={info["className"]} key={info["label"]}>
                      <label className={info["labelClassName"]}>
                        {info["label"]}
                      </label>
                      <select
                        className={info["inputClassName"]}
                        onChange={(newValue) => {
                          myForm.handleChangeForSelect(newValue, info["name"]);
                        }}
                        disabled={checkDisabledCondition(info)}
                        value={myForm.pageState[info["name"]]}
                        ref={(a) =>
                          myForm.storeInputReferenceForSelect(a, info["name"])
                        }
                        onKeyPress={(a) => myForm.onKeyPressForKeyNav(a, info)}
                      >
                        {info["dropdown_items"].map((dropdown_item) => (
                          <option
                            value={dropdown_item.value}
                            key={dropdown_item.label}
                          >
                            {dropdown_item.label}
                          </option>
                        ))}
                      </select>
                      {myForm.internalValidationErrors[info["name"]] && (
                        <p>{myForm.internalValidationErrors[info["name"]]}</p>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div className={info["className"]} key={info["label"]}>
                      {checkVisibilityCondition(info) && (
                        <label className={info["labelClassName"]}>
                          {info["label"]}
                        </label>
                      )}
                      {checkVisibilityCondition(info) && (
                        <Autosuggest
                          id={info["name"]}
                          suggestions={myForm.suggestions || ""}
                          onSuggestionsFetchRequested={(a) =>
                            myForm.onSuggestionsFetchRequested(a, (b) =>
                              myForm.suggestionFetchApi(info, b)
                            )
                          }
                          onSuggestionsClearRequested={() =>
                            myForm.onSuggestionsClearRequested(info)
                          }
                          getSuggestionValue={(a) =>
                            myForm.getSuggestionValue(
                              a,
                              info,
                              myForm.performSuggestions,
                              myForm.updatePageStateForGetSuggestion
                            )
                          }
                          renderSuggestion={(a) => myForm.renderSuggestion(a, info)}
                          ref={(a) => myForm.storeInputReference(a, false)}
                          inputProps={{
                            placeholder: info["placeholder"],
                            value: String(myForm.pageState[info["name"]]),
                            onChange: (a, b) => {
                              myForm.onChangeAutoSuggest(a, b, info);
                            },
                            onBlur: () => {
                              info["toValidate"]
                                ? myForm.onblurValidator(info)
                                : {};
                            },
                            onKeyPress: (a) => myForm.onKeyPressForKeyNav(a, info),
                            disabled: checkDisabledCondition(info),
                          }}
                        />
                      )}
                      {myForm.internalValidationErrors[info["name"]] && (
                        <p>{myForm.internalValidationErrors[info["name"]]}</p>
                      )}
                    </div>
                  );
                }
              })}
          </div>
          {process.env.REACT_APP_CLIENT !== "sra" && <div className="field-container">
            {groupInfo["group-4"].map(function (info) {
              return (
                <div className={info["className"]} key={info["label"]}>
                  {checkVisibilityCondition(info) && (
                    <label className={info["labelClassName"]}>
                      {info["label"]}
                    </label>
                  )}
                  {checkVisibilityCondition(info) && (
                    <input
                      id="responsive-form-input"
                      className={info["className"]}
                      type={info["type"]}
                      name={info["name"]}
                      placeholder={info["placeholder"]}
                      value={myForm.pageState[info["name"]]}
                      onChange={myForm.handleChange}
                      onBlur={() => {}}
                      disabled={true}
                    />
                  )}
                  {myForm.internalValidationErrors[info["name"]] && (
                    <p>{myForm.internalValidationErrors[info["name"]]}</p>
                  )}
                </div>
              );
            })}
          </div>}
        </div>
        <div className="form-footer">

        <div className="info-left">
        <b>  C : </b><span> Carton wise Charge </span>&nbsp;&nbsp;
        <b>  W : </b><span> Weight wise Charge </span>&nbsp;&nbsp;
        <b>  T : </b><span> Trip wise Charge </span>&nbsp;&nbsp;
        <b>  F : </b><span> FTL wise Charge </span>&nbsp;&nbsp;
        </div>
        {
            parseInt(process.env.REACT_APP_USE_FRONTEND_BILTY_PRINT) ? (
            <ReactToPrint
            trigger={() => (
              <button
                onClick={() => {
                  console.log("Values", myForm.pageState);
                  console.log(
                    "Value verification",
                    myForm.valueVerificationState
                  );
                  console.log("Id clearance", myForm.idClearancState);
                  console.log("Reference store", myForm.refStoreObject.current);
                  console.log("Session", sessionObject.sessionVariables);
                  console.log("Page mode", myForm.pageMode);
                }}
                ref={(a) =>
                  myForm.storeInputReferenceForSelect(a, "print_button")
                }
                type="button"
                className="btn btn-primary"
              >
                Print
              </button>
            )}
            content={(myForm) => ComponentToPrint.componentRef}
            onBeforeGetContent={checkPrint}
            onAfterPrint={() => {
              myForm.setPageState({
                ...dataObject,
                ...variablesFromSession,
              });
              myForm.setPageMode("write");
              window.location.reload();
              // close();
            }}
          /> 
          ) : (
            <>
              <button
                onClick={(e) => {
                  myForm.setServerPrintNeeded(true);
                  myForm.handleSubmit(e);
                }}
                type="button"
                ref={(a) => myForm.storeInputReferenceForSelect(a, "print_button")}
                className="btn btn-primary"
                disabled={myForm.pageState.is_crossing == "Y" && process.env.REACT_APP_CLIENT_NAME == "ASHAPURA TRANSPORT"}
              >
                Print
              </button>
              <button
                onClick={(e) => {
                  myForm.setPrintType("sticker");
                  myForm.setServerPrintNeeded(true);
                  myForm.handleSubmit(e);
                }}
                type="button"
                ref={(a) =>
                  myForm.storeInputReferenceForSelect(a, "print_sticker_button")
                }
                className="btn btn-primary"
              >
                Print Sticker
              </button>
              {process.env.REACT_APP_CLIENT == "jkl" && <button
                onClick={(e) => {
                  myForm.setPageState((oldState) => ({
                    ...oldState,
                    extra_print: true
                  }))
                  myForm.setServerPrintNeeded(true);
                  myForm.handleSubmit(e);
                }}
                type="button"
                className="btn btn-primary"
              >
                Template
              </button>}
            </>
          )
            
          }

          <button
            onClick={(e) => {
              myForm.setClearDataOnSave(true);
              myForm.handleSubmit(e);
            }}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          {checkVisibilityCondition({ name: "delete_button" }) && (
            <button onClick={() => myForm.setDeletePopup(true)} className="btn btn-primary">Delete</button>
          )}
          <button
            onClick={() => {
              history.push("/");
              // console.log("Values", myForm.pageState);
              //     console.log(
              //       "Value verification",
              //       myForm.valueVerificationState
              //     );
              //     console.log("Id clearance", myForm.idClearancState);
              //     console.log("Reference store", myForm.refStoreObject.current);
              //     console.log("Session", sessionObject.sessionVariables);
              //     console.log("Page mode", myForm.pageMode);
            }}
            className="btn btn-primary"
          >
            Exit
          </button>
          <button
            onClick={() => {
              myForm.setPageState({
                ...dataObject,
                ...variablesFromSession,
              });
              window.location.reload();
              myForm.setPageMode("write");
            }}
            className="btn btn-primary"
          >
            New
          </button>
          {/* <div className="status">{myForm.renderSubmitApiResponseStatus()}</div> */}
        </div>
      </div>
      <ComponentToPrint
        fields={myForm.pageState}
        ref={(el) => (ComponentToPrint.componentRef = el)}
      />
    </div>
  );
};

export default FormSignup;
